import { SearchResultItem } from './search-result-item';
import { Observable } from 'rxjs/Observable';
import { EventEmitter } from '@angular/core';

export abstract class NavSearchInputProvider {

  protected response : Observable<SearchResultItem[]>;
  protected emitter : EventEmitter<SearchResultItem[]>;

  constructor() {
    this.response = Observable.create((e : EventEmitter<SearchResultItem[]>) => this.emitter = e);
  }

  getSubscription() : Observable<SearchResultItem[]> {
    return this.response;
  }

  clear() : void {
    this.emitter.next([]);
  }

  abstract search(text : string) : void;

}
